import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { SwapDetailsContainer, ExchangePairs, SendAssetIcon, SendAssetAmount, ArrowIcon, RecieveAssetIcon, RecieveAssetAmount, } from './styles';
const SwapDetailsLoader = () => {
    const { colors } = useTheme();
    return (_jsx(SwapDetailsContainer, { children: _jsxs(ExchangePairs, { backgroundColor: colors.surface.interactiveDefault, foregroundColor: colors.surface.pressed, children: [_jsx(SendAssetIcon, {}), _jsx(SendAssetAmount, {}), _jsx(ArrowIcon, {}), _jsx(RecieveAssetIcon, {}), _jsx(RecieveAssetAmount, {})] }) }));
};
export default SwapDetailsLoader;
//# sourceMappingURL=SwapDetailsLoader.js.map